// extracted by mini-css-extract-plugin
export default {"header":"header_header__TRXcv","myButton":"header_myButton__TS9IC","teamIcon":"header_teamIcon__odIvX"};